import React, { useEffect, useState } from "react";
import Searchicon from '../../../common/icon/searchicon.png';
import { Col, Row } from "react-bootstrap";
import Card from 'react-bootstrap/Card';
import toast from 'react-hot-toast';
import EditPng from '../../../common/icon/editorg.svg';
import ArrowPng from "../../../common/icon/Arrow.svg";
import Norecord from '../../../component/Norecordui';
import { FaTimes } from 'react-icons/fa';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useParams } from 'react-router-dom';
import { apiurl, organizer_url, get_date_time, eventnameurl } from '../../../common/Helpers';
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import {
    Modal,
    ModalBody,
    ModalHeader
} from 'reactstrap'
const Dashboard = ({ title }) => {
    const [Loader, setLoader] = useState(false);
    const { id, name } = useParams();
    const navigate = useNavigate();
    const [Ticketshow, setTicketshow] = useState(false);
    const [Listitems, setListitems] = useState([]);
    const [allEvents, setallEvents] = useState([]);
    const [Ticketsoldlist, setTicketsoldlist] = useState([]);
    const [Eventdata, setEventdata] = useState([]);
    const [TicketStartdate, setTicketStartdate] = useState(new Date());
    const [TicketEndtdate, setTicketEndtdate] = useState(new Date());
    const [EditApiLoader, setEditApiLoader] = useState(false);
    const [IsEdit, setIsEdit] = useState(false);
    const [IsSellingFast, setIsSellingFast] = useState(false);
    const [IsSoldOut, setIsSoldOut] = useState(false);
    const [showPromoForTicket, setShowPromoForTicket] = useState(null);
    const [promoData, setPromoData] = useState([]);
    const [eventCoupon, setEventCoupon] = useState([]);
    const [EventTaxList,setEventTaxList] = useState([]);
    const [promoCouponData, setpromoCouponData] = useState([]);
    const fetchCouponUsage = () => {
    try {
        const requestData = {
            eventvalue: id   // your event id
        };

        fetch(apiurl + 'event/organizer/coupon-usage', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        })
        .then(response => response.json())
        .then(data => {
            if (data.success === true) {
                console.log("Coupon Usage Data:", data.data);
                setpromoCouponData(data.data);   // store coupon data
            } else {
                toast.error("Failed to load coupon usage");
            }
        })
        .catch(error => {
            console.error("Coupon API error:", error);
        });

    } catch (error) {
        console.error("API error:", error);
    }
};
    const fetchEventTaxCalList = async () => {        
    try {
        setLoader(true);
        const requestData = {
            eid: id
        };
        fetch(apiurl + 'event/event-tax-cal-list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestData),
        })
            .then(response => response.json())
            .then(data => {                
                 console.log('Absorbed Tax List:', data.data);
                if (data.success === true) {                   
                    setEventTaxList(data.data);
                    console.log('Absorbed Tax List:', data.data);
                }
                setLoader(false);
            })
            .catch(error => {
                console.error('Fetch tax error:', error);
                setLoader(false);
            });

    } catch (error) {
        console.error('API error:', error);
        setLoader(false);
    }
};

    const fetchAllTicket = async () => {        
        try {
            setLoader(true);
            const requestData = {
                updateid: id
            };
            fetch(apiurl + 'event/ticket-list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Set the Content-Type header to JSON
                },
                body: JSON.stringify(requestData),
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success == true) {
                        const fetchdata = data.data.allprice.filter(item => item.isdelete === 0);
                        setTicketsoldlist(data.ticketdata);                        
                        setListitems(fetchdata);
                        console.log(fetchdata);
                        setallEvents(fetchdata);                        
                    }
                    setLoader(false);
                })
                .catch(error => {
                    console.error('Insert error:', error);
                    setLoader(false);
                });

        } catch (error) {
            console.error('Api error:', error);
            setLoader(false);
        }
    }

    const CountTicketSold = (id) => {        
        const filteredList = Ticketsoldlist.filter(item => item.ticket_id === id);
        return filteredList.reduce((total, item) => total + Number(item.quantity), 0);
    };
    const fetchEvent = async () => {
        try {
            setLoader(true);
            const requestData = {
                id: id
            };
            fetch(apiurl + 'event/get-details', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Set the Content-Type header to JSON
                },
                body: JSON.stringify(requestData),
            })
                .then(response => response.json())
                .then(data => {

                    if (data.success == true) {
                        setEventdata(data.data);
                    }
                    setLoader(false);
                })
                .catch(error => {
                    console.error('Insert error:', error);
                    setLoader(false);
                });

        } catch (error) {
            console.error('Api error:', error);
            setLoader(false);
        }
    }
          const fetchPromoSummary = async () => {
    try {
      

      const requestData = { eventId: id };

      const response = await fetch(
        apiurl + "event/organizer/event-promo-summary",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      const data = await response.json();
      console.log("Promo Summary Response:", data);
      if (data.success) {
        setPromoData(data.data); // save all promo codes
        console.log("Promo Summary:", data.data);
      } else {
        setPromoData([]);
        console.log("No promo data available");
      }

   
    } catch (error) {
      console.error("Fetch promo summary error:", error);
     
    }
  };
  useEffect(() => {
    fetchCouponUsage();
    fetchPromoSummary();
    fetchEventTaxCalList();
  }, [id]);
    const fromticketgetdate = get_date_time(TicketStartdate);
    var ticketstartdate = '';
    var ticketstarttime = '';
    if (fromticketgetdate) {
        ticketstartdate = fromticketgetdate[0].Dateview;
        ticketstarttime = fromticketgetdate[0].Timeview;
    }
    const toticketgetdate = get_date_time(TicketEndtdate);
    var ticketenddate = '';
    var ticketendtime = '';
    if (toticketgetdate) {
        ticketenddate = toticketgetdate[0].Dateview;
        ticketendtime = toticketgetdate[0].Timeview;
    }
    useEffect(() => {
        fetchAllTicket();
        fetchEvent();
    }, []);
    const [searchTerm, setSearchTerm] = useState('');
    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchTerm(value);
        // Now filter the events based on the search term
        if (value) {

            const filteredEvents = allEvents.filter(event =>
                event.name.toLowerCase().includes(value.toLowerCase()));
            setListitems(filteredEvents);
        } else {
            // If the search term is empty, reset to show all events
            setListitems(allEvents);
        }
    };
    const EditEvent = async (id, name, ticketid) => {
        navigate(`${organizer_url}event/edit-event/${id}/${eventnameurl(name)}/${ticketid}`);
    }
    const handleIsSellingFast = (ticketid, value) => {
        try {
            const requestData = {
                updateid: id,
                ticketid: ticketid,
                status: value
            };
            fetch(apiurl + 'event/update-ticket-sellingfast', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Set the Content-Type header to JSON
                },
                body: JSON.stringify(requestData),
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success == true) {
                        toast.success(data.message);
                    } else {
                        toast.error(data.message);
                    }
                    fetchAllTicket();
                })
                .catch(error => {
                    console.error('Insert error:', error);
                });

        } catch (error) {
            console.error('Api error:', error);
        }
    };
    const handleIsSoldOut = (ticketid, value) => {
        try {
            const requestData = {
                updateid: id,
                ticketid: ticketid,
                status: value
            };
            fetch(apiurl + 'event/update-ticket-soldout', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Set the Content-Type header to JSON
                },
                body: JSON.stringify(requestData),
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success == true) {
                        toast.success(data.message);
                    } else {
                        toast.error(data.message);
                    }
                    fetchAllTicket();
                })
                .catch(error => {
                    console.error('Insert error:', error);
                });

        } catch (error) {
            console.error('Api error:', error);
        }
    };
    const handleIsHide = (ticketid, value) => {
        try {
            const requestData = {
                updateid: id,
                ticketid: ticketid,
                status: value
            };
            fetch(apiurl + 'event/update-ticket-hide', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', // Set the Content-Type header to JSON
                },
                body: JSON.stringify(requestData),
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success == true) {
                        toast.success(data.message);
                    } else {
                        toast.error(data.message);
                    }
                    fetchAllTicket();
                })
                .catch(error => {
                    console.error('Insert error:', error);
                });

        } catch (error) {
            console.error('Api error:', error);
        }
    };
    const totalAvailableTickets = Listitems.reduce((total, item) => {
        return total + (parseInt(item.quantity, 10) * item.groupqty - parseInt(CountTicketSold(item.id), 10) * item.groupqty);
    }, 0);

const handleViewPromo = (ticketId) => {

  if (showPromoForTicket === ticketId) {
    setShowPromoForTicket(null);
  } else {

    const ticketPromo = promoData.filter((promo) => {

      // GLOBAL promo
      if (promo.ticketValue === "1") {
        return true;
      }

      // Ticket specific promo
      return String(promo.ticketValue) === String(ticketId);
    });

    const updatedListItems = Listitems.map((item) => {
      if (item.id === ticketId) {
        return { ...item, promocodes: ticketPromo };
      }
      return item;
    });

    setListitems(updatedListItems);
    setShowPromoForTicket(ticketId);
  }
};
const getAbsorbedTaxForTicket = (ticketId) => {
    return EventTaxList.reduce((total, tax) => {
        if (tax.isglobal === '1') {
            return total + Number(tax.taxamount);
        }

        if (tax.isglobal === '0' && tax.ticketid === ticketId) {
            return total + Number(tax.taxamount);
        }

        return total;
    }, 0);
};


const CountTicketRevenue = (ticketId) => {

    return Ticketsoldlist
        .filter(item => item.ticket_id === ticketId)
        .reduce((total, item) => {           
            const qty = Number(item.quantity);
            const basePrice = Number(item.ticket_price);

            // Find matching coupon by order_id
            const coupon = promoCouponData.find(
                p => p.order_id === item.orderid
            );
            console.log('Matching coupon for order', item.orderid, ':', coupon);
            let finalPrice = basePrice;

            if (coupon) {
                if (coupon.type === "percentage") {
                    finalPrice = basePrice - (basePrice * coupon.discount / 100);
                } else if (coupon.type === "amount") {
                    finalPrice = basePrice - coupon.discount;
                }
            }

            return total + Math.max(finalPrice * qty, 0);

        }, 0);
};
// const CountTicketRevenue = (ticketId) => {    
//     const absorbedTaxPerTicket = getAbsorbedTaxForTicket(ticketId);
//     console.log('ob'+absorbedTaxPerTicket);
//     return Ticketsoldlist
//         .filter(item => item.ticket_id === ticketId)
//         .reduce((total, item) => {
//             const pricePerTicket = Number(item.order_amount);
//             const qty = Number(item.quantity);

//             const finalPricePerTicket =
//                 pricePerTicket - (absorbedTaxPerTicket*qty);

//             const ticketRevenue =
//                 Math.max(finalPricePerTicket, 0);

//             console.log(
//                 `Price: ${pricePerTicket}, Tax: ${absorbedTaxPerTicket}, Qty: ${qty}`
//             );

//             return total + ticketRevenue;
//         }, 0);
// };

const totalRevenue = Listitems.reduce(
    (total, item) => total + CountTicketRevenue(item.id),
    0
);

    return (
        <>
            <div className="content-body" style={{ background: '#F1F1F1' }}>
                <div className="container-fluid">
                    <Row className="justify-content-center">
                        <Col md={12}>
                            <Card className="py-4 grey-bg">
                                <Card.Body>
                                    <Row className="justify-content-center">
                                        <Col md={12}>
                                            <Row>
                                                <Col md={4} xl={5}>
                                                    <div class="input-group mb-3 input-warning-o">
                                                        <span class="input-group-text"><img src={Searchicon} alt="" /></span>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search ticket name"
                                                            value={searchTerm}
                                                            onChange={handleSearchChange}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4} xl={3}>
                                                    <button className="w-100 theme-btn-warning" onClick={() => navigate(`${organizer_url}event/manage-attendee/${Eventdata._id}/${eventnameurl(Eventdata.name)}`)}>
                                                        <span>Manage All Attendee</span>
                                                    </button>
                                                    
                                                </Col>
                                                
                                                {/* <Col md={4} xl={4} className="d-flex justify-content-end">
                                                    <button className="theme-btn" onClick={() => { setTicketshow(true); setIsEdit(false); }}>
                                                        <span className="theme-btn-icon"><FiPlus /></span> <span>Add Ticket</span>
                                                    </button>
                                                </Col> */}
                                            </Row>
                                        </Col>
                                        {Loader ? (
                                            <div className="linear-background w-100"> </div>
                                        ) : (
                                            <>
                                         
                                                {Listitems.length > 0 ? (
                                                    <>
                                                        {Listitems.map((item, index) => (
                                                            <>
                                                                {index == 0 && (
                                                                    <Col md={12} className="event_list_box_main in-ticket-list-1 p-0">
                                                                        <Row>
                                                                            <div className="col-md-3 col-lg-3 col-xl-3">
                                                                                <div className="text-center border-theme">
                                                                                    <p class="mb-1 text-capitalize">Total Ticket</p>
                                                                                    <h3 class="mb-0 theme-text font-w600">{Listitems.reduce((total, item) => total + (item.quantity * item.groupqty), 0)}</h3>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-3 col-lg-3 col-xl-3">
                                                                                <div className="text-center border-theme">
                                                                                    <p class="mb-1 text-capitalize">Ticket Sold</p>
                                                                                    <h3 class="mb-0 theme-text font-w600">{Listitems.reduce((total, item) => {
    const ticketCount = CountTicketSold(item.id);
    return total + (isNaN(ticketCount) ? 0 : ticketCount * Number(item.groupqty));
}, 0)}</h3>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-3 col-lg-3 col-xl-3">
                                                                                <div className="text-center border-theme">
                                                                                    <p class="mb-1 text-capitalize">Ticket Available</p>
                                                                                    <h3 class="mb-0 theme-text font-w600">{totalAvailableTickets}</h3>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-3 col-lg-3 col-xl-3">
                                                                                <div className="text-center border-theme">
                                                                                    <p class="mb-1 text-capitalize">Revenue</p>
                                                                                    <h3 class="mb-0 theme-text font-w600">{Eventdata.countrysymbol}{totalRevenue}</h3>
                                                                                </div>
                                                                            </div>
                                                                        </Row>
                                                                    </Col>
                                                                )}
                                                                <Col md={12} className="event_list_box_main in-ticket-list-1 p-0">
                                                                    <button onClick={() => navigate(`${organizer_url}event/manage-attendee/${Eventdata._id}/${eventnameurl(Eventdata.name)}/${item.id}`)} className="list-active-ticket-btn" type="button">Attendee  <img src={ArrowPng} className="arraw-svg ml-3" alt="" /></button>
                                                                     <button 
                                                                                        onClick={() => handleViewPromo(item.id)}                    
                                                                                        type="button"
                                                                                         style={{
                                                                            background: "#0047ab",
                                                                            color: "#fff",
                                                                            fontSize: "13px",
                                                                            fontWeight: 400,
                                                                            textTransform: "uppercase",
                                                                            border: 0,
                                                                            padding: "28px 30px 6px 30px",
                                                                            borderRadius: "0px 0px 10px 10px",
                                                                            position: "absolute",        
                                                                            bottom: "-30px",
                                                                            zIndex: -1,
                                                                            display: "flex",
                                                                            alignItems: "center"
                                                                        }}
                                                                                    >
                                                                                        Promo  <img src={ArrowPng} className="arraw-svg ml-3" alt="" />
                                                                                    </button>
                                                                    <div className="event_list_box p-0">
                                                                        <Row>
                                                                            <Col md={2} className="d-flex align-items-center justify-content-center">
                                                                                <div className="text-center pl-1">
                                                                                    <span className="ticket-list-name">{item.name}</span> <span className="cursor-pointre list-event-edit-btn editbtn-mng-tic" onClick={() => EditEvent(Eventdata._id, Eventdata.name, item.id)}><img src={EditPng} alt="" /></span>
                                                                                    <p className="ticket-list-price_title mb-0">Price</p>
                                                                                    <p className="ticket-list-price_value">{item.ticket_type == 1 ? Eventdata.countrysymbol + ' ' + item.price : 'Free'}</p>
                                                                                </div>
                                                                            </Col>
                                                                            <Col md={8}>
                                                                                <div>
                                                                                    <Row className="py-4">
                                                                                        <Col md={3} className="ticket-sts-box  text-center border-right">
                                                                                            <p>Total Ticket</p>
                                                                                            <h2>{item.quantity * item.groupqty}</h2>
                                                                                        </Col>
                                                                                        <Col md={3} className="ticket-sts-box  text-center  border-right">
                                                                                            <p>Ticket Sold</p>
                                                                                            <h2>{CountTicketSold(item.id) * item.groupqty}</h2>
                                                                                        </Col>
                                                                                        <Col md={3} className="ticket-sts-box  text-center  border-right">
                                                                                            <p>Ticket Available</p>
                                                                                            <h2><h2>{parseInt(item.quantity, 10) * item.groupqty - parseInt(CountTicketSold(item.id), 10) * item.groupqty}</h2></h2>
                                                                                        </Col>
                                                                                   <Col md={3} className="ticket-sts-box text-center">
    <p>Revenue</p>
    <h2>
        {CountTicketRevenue(item.id) > 0 ? (
            <>
                {Eventdata.countrysymbol}
                {CountTicketRevenue(item.id)}
            </>
        ) : (
            'FREE'
        )}
    </h2>
</Col>

                                                                                    </Row>
                                                                                </div>
                                                                            </Col>
                                                                            <Col md={2} className="d-flex align-items-center">
                                                                                <div className="">
                                                                                    <div class="input-group mb-3 d-flex align-items-center">
                                                                                        <input id={`sellingfirst${index}`} checked={item.isselling} onChange={(event) => handleIsSellingFast(item.id, event.target.checked)} type="checkbox" class="form-check-input" /><label className="mx-2 mb-0" style={{ fontSize: '10px' }} for={`sellingfirst${index}`}>Is Selling Fast</label>
                                                                                    </div>
                                                                                    <div class="input-group mb-3  d-flex align-items-center">
                                                                                        <input id={`soldout${index}`} checked={item.issoldout} onChange={(event) => handleIsSoldOut(item.id, event.target.checked)} type="checkbox" class="form-check-input" /><label className="mx-2  mb-0" style={{ fontSize: '10px' }} for={`soldout${index}`}>Is Sold Out</label>
                                                                                    </div>
                                                                                    <div class="input-group mb-3  d-flex align-items-center">
                                                                                        <input id={`tickethide${index}`} checked={item.tickethide} onChange={(event) => handleIsHide(item.id, event.target.checked)} type="checkbox" class="form-check-input" /><label className="mx-2  mb-0" style={{ fontSize: '10px' }} for={`tickethide${index}`}>Hide</label>
                                                                                    </div>
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
  <Col md={12}>
    {showPromoForTicket === item.id && (
      <div className="promo-code-section mt-3">
        <h5>Promo Codes for {item.name}</h5>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Promo Code Name</th>
              <th>Total Use</th>
              <th>Total Ticket</th>
            </tr>
          </thead>
          <tbody>
            {item.promocodes && item.promocodes.length > 0 ? (
              item.promocodes.map((code) => (
                <tr key={code._id}>
                  <td>{code.couponName}</td>
                  <td>{code.totalOrder}</td>
                  <td>{code.totalTicket}</td>
                  
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center">
                  No Promo Codes
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )}
  </Col>
</Row>
                                                                    </div>
                                                                </Col>
                                                            </>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <Norecord />
                                                )}
                                            </>
                                        )}
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div >
        </>
    )
}
export default Dashboard;